const AUDIO_ACCEPT = '.wav,.mp3,.m4a';
const MAX_SIZE = 10 * 1024 * 1024; // 10MB
const MIN_DURATION = 10; // seconds
const MAX_DURATION = 30; // seconds

const STEPS = {
  UPLOAD_AUDIO: 'uploadAudio',
  PREVIEW_AUDIO: 'previewAudio',
  RECORD_AUDIO: 'recordAudio',
  CREATE_VOICE_CLONE: 'createVoiceClone',
};

export { AUDIO_ACCEPT, MAX_SIZE, MIN_DURATION, MAX_DURATION, STEPS };
